var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactivateSubscriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 33.25C69.5 29.6367 67.1562 26.5117 63.8359 25.2422C65.3008 22.1172 64.7148 18.2109 62.1758 15.5742C59.5391 13.0352 55.6328 12.4492 52.5078 13.9141C51.2383 10.5938 48.1133 8.25 44.5 8.25C40.7891 8.25 37.6641 10.5938 36.3945 13.9141C33.2695 12.4492 29.3633 13.0352 26.8242 15.5742C24.1875 18.2109 23.6016 22.1172 25.0664 25.2422C21.7461 26.5117 19.5 29.6367 19.5 33.25C19.5 36.9609 21.7461 40.0859 25.0664 41.3555C23.6016 44.4805 24.1875 48.3867 26.8242 50.9258C29.3633 53.5625 33.2695 54.1484 36.3945 52.6836C37.6641 56.0039 40.7891 58.25 44.5 58.25C48.1133 58.25 51.2383 56.0039 52.5078 52.6836C55.7305 54.1484 59.5391 53.5625 62.1758 50.9258C64.7148 48.3867 65.3008 44.4805 63.8359 41.3555C67.1562 40.0859 69.5 36.9609 69.5 33.25ZM55.3398 28.9531L42.5469 41.6484C42.0586 42.1367 41.375 42.0391 40.9844 41.6484L33.5625 34.2266C33.1719 33.8359 33.1719 33.1523 33.5625 32.6641L36.1016 30.125C36.5898 29.7344 37.2734 29.7344 37.6641 30.2227L41.7656 34.3242L51.2383 24.9492C51.7266 24.4609 52.4102 24.4609 52.8008 24.9492L55.3398 27.4883C55.7305 27.8789 55.7305 28.5625 55.3398 28.9531Z",
    fill: "#7CD7E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1956 19.8453C76.4207 19.8453 79.0244 17.1391 79.0244 13.8108C79.0244 10.4826 76.4207 7.77638 73.1956 7.77638C72.7221 7.77638 72.2487 7.83858 71.8049 7.96301L71.3019 8.08743L71.2427 7.55864C70.8285 3.26608 67.3371 0 63.1652 0C59.9696 0 57.0404 1.95965 55.7385 4.97688L55.6202 5.22573L55.3539 5.25683C53.2827 5.38125 51.4778 6.84321 50.8565 8.86507L50.7085 9.33165L50.2647 9.14502C49.6434 8.89618 48.9628 8.74064 48.2823 8.74064C45.3235 8.74064 42.9268 11.2291 42.9268 14.2774C42.9268 17.2325 45.1756 19.6587 48.016 19.8142H48.164H73.1956V19.8453Z",
    fill: "url(#paint0_linear_21068_39553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49212 63.8473C3.61663 63.8473 0.487793 60.5953 0.487793 56.5959C0.487793 52.5964 3.61663 49.3445 7.49212 49.3445C8.061 49.3445 8.62989 49.4192 9.16321 49.5687L9.76765 49.7183L9.83876 49.0828C10.3365 43.9246 14.532 39.9999 19.5453 39.9999C23.3852 39.9999 26.9052 42.3547 28.4696 45.9804L28.6118 46.2794L28.9318 46.3168C31.4207 46.4663 33.5895 48.2231 34.3362 50.6527L34.5139 51.2134L35.0473 50.9891C35.7939 50.6901 36.6117 50.5032 37.4294 50.5032C40.9849 50.5032 43.8649 53.4935 43.8649 57.1565C43.8649 60.7075 41.1627 63.623 37.7494 63.8099H37.5717H7.49212V63.8473Z",
    fill: "url(#paint1_linear_21068_39553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21068_39553",
    x: 36.9268,
    y: -6,
    width: 48.0977,
    height: 31.8453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21068_39553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21068_39553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21068_39553",
    x: -5.51221,
    y: 33.9999,
    width: 55.3772,
    height: 35.8474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21068_39553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21068_39553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21068_39553",
    x1: 60.9756,
    y1: 0,
    x2: 60.9756,
    y2: 19.8453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#E7F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21068_39553",
    x1: 22.1763,
    y1: 39.9999,
    x2: 22.1763,
    y2: 63.8473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#E7F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF6FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivateSubscriptionIcon);
export default __webpack_public_path__ + "static/media/ReactivateSubscriptionIcon.1dc7f68a.svg";
export { ForwardRef as ReactComponent };